export default __webpack_public_path__ + "static/media/ufabetpng.259131ae.png";